export default async function getConnectedAddress(web3) {
  const signer = web3.getSigner();
  const address = await signer.getAddress();
  return address.toLowerCase();
}
